export enum DeliveryTimeOptionEnum {
    MORNING = "Morning",
    AFTERNOON = "Afternoon",
    ANYTIME = "Anytime"
}
